module.exports = __webpack_public_path__ + "img/Screenshot_20230817_123530_Messages.a3e9f8b3.jpg";